import PropTypes from 'prop-types';
import { SOCIAL_PLATFORMS } from '~/constants';

import { creatorBrandType } from './creator-brand';

export const mediaPackPlatformType = PropTypes.oneOf([
  SOCIAL_PLATFORMS.instagram,
  SOCIAL_PLATFORMS.tiktok,
  SOCIAL_PLATFORMS.youtube,
]);

export const mediaPackAboutMeContentType = PropTypes.shape({
  id: PropTypes.string,
  platform: PropTypes.string,
  type: PropTypes.string,
});

export const mediaPackType = PropTypes.shape({
  aboutMeContent: mediaPackAboutMeContentType,
  id: PropTypes.string,
  name: PropTypes.string,
  creator: creatorBrandType,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  metricsUpdatedAt: PropTypes.string,
  platforms: PropTypes.arrayOf(mediaPackPlatformType),
});
